
/**
 * package: com.inq.flash.client.chatskins
 * class: ChatTextFocusMonitorImplResize
 * root ChatTextFocusMonitorImplBase
 * @constructor
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplResize = function() {
    com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.call(this);

};

$hxClasses.extend(com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase, com.inq.flash.client.chatskins.ChatTextFocusMonitorImplResize, 'com.inq.flash.client.chatskins.ChatTextFocusMonitorImplResize');

/**
 * This is currently (as of MOB-599) a bucket to hold everything that
 * needs to be moved into subclasses.
 * onFocusRelatedTargetImpl
 * @deprecated
 * @public
 * @param {FocusEvent} ev
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplResize.prototype.onFocusRelatedTargetImpl = function (ev) {
	this.setHasFocus(true);
    return false;
};

/**
 * onBlurImpl - Restore the original scroll position & chat dimensions.
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => true }],TEnum(Bool,[]))
 * static public function onBlur(?me:MouseEvent):Bool
 * @public
 * @static
 * @param {FocusEvent}  ev
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplResize.prototype.onBlurImpl = function (ev) {
    this.unbindOrientationListener();
    this.blurToken = null;
    return true;
};

/**
 * resizeToViewport
 * Resize the chat so that it fills the viewport.
 *@calledBy
        com.inq.flash.client.chatskins.ChatTextFocusMonitor.restoreWindowPosition - never should be removed
        com.inq.stage.ViewportMgrImplMobile.prototype.fixPositioning ( which is called in show )
        which is called by resize chat which is called by upon orientation change which doesnt fire on android
 * @public
 * @static
 * @param {string}  from
 * @return {void}
 */

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplResize.prototype.resizeToViewportImpl = function (from) {
	/** @type {Window} */
	var clientWin = window.top;
    viewPort = com.inq.utils.Capabilities.getViewport();
    Application.SetArea(viewPort);
    this.zoomViewport(clientWin);
    this.scrollTranscriptToEnd();
    this.bResizeToViewport = false;
};

/**
 * This was discovered in ChatTextFocusMonitorImplAndroid.js. The code was exactly as below,
 * but I suspect that it's been causing bugs by hiding in the wrong file, AND I suspect
 * that it was INTENDED to be in the Android CTFM, but is not.
 *
 * I'm going to
 *
 * onFocusImpl - Handler for focus events on the chat interface's text
 * input area.
 * $type TFun([],TEnum(Bool,[]))
 * static public function onFocus():Bool
 * @public
 * @static
 * @param {FocusEvent}  ev
 * @return {boolean}
 */
	com.inq.flash.client.chatskins.ChatTextFocusMonitorImplResize.prototype.onFocusImpl = function (ev,element) {
		this.focusElement = element;
		this.bindOrientationListener(); // In the hopes that resizeToViewport will be called?
		this.focusToken = null;
		/**
		 * http://jira.touchcommerce.com/browse/MOB-773
		 * waiting for viewport to finish adjustment before scrolling to end
		 */
		if (this.hasFocus) {
			var that = this;

			com.inq.utils.Capabilities.waitFor(com.inq.utils.Capabilities.viewportStopsMoving(800), 200, function () {
				com.inq.flash.client.chatskins.SkinControl.scrollTranscriptToEnd();

				//RTDEV-27010: Textarea is hidden under the soft keypad in post chat survey - Android
				if (that.isInputElement(that.focusElement)) {
					var vph = window.top.innerHeight;
					var elePos = that.focusElement.getBoundingClientRect().top;
					if (elePos > vph) { //This means that the focus element is hidden under the soft keypad, generally in post chat surveys
						element.scrollIntoView();//brings the element into focus
					}
				}
			});
		}
		return true;
	};


